import { Component, Injector } from '@angular/core';
import { ClubsService } from 'src/app/pages/clubs/clubs.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { Club } from './club.model';
@Component({
  selector: 'app-clubs',
  templateUrl: './clubs.component.html',
  styleUrls: ['./clubs.component.css']
})
export class ClubsComponent extends BaseListComponent<Club> {
 
  constructor(
    public clubsServ:ClubsService,
    public auth:AuthService,
    public injector:Injector
    ) { 
      super(clubsServ,injector,'club',{createUrl:'/admin/clubs/new',editUrl:'/admin/clubs/edit',detailUrl:'/admin/clubs/detail'})
    }

  protected tableProprieties(): string[] {
    return [
     'Clube',
     'Email',
     'Telefone',
     'Provincia',
     'Endereço',
    ]
  }

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}
}
